/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationPolicyDetailResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputTeamNameMax = 120;

export const notificationPolicyDetailResponseOutputNameMax = 120;

export const notificationPolicyDetailResponseOutputVersionExclusiveMin = 0;
export const notificationPolicyDetailResponseOutputVersionMax = 9007199254740991;

export const notificationPolicyDetailResponseOutputStepCountExclusiveMin = 0;
export const notificationPolicyDetailResponseOutputStepCountMax = 9007199254740991;

export const notificationPolicyDetailResponseOutputMinDelayMinutesMin = 0;
export const notificationPolicyDetailResponseOutputMinDelayMinutesMax = 1440;

export const notificationPolicyDetailResponseOutputMaxDelayMinutesMin = 0;
export const notificationPolicyDetailResponseOutputMaxDelayMinutesMax = 1440;

export const notificationPolicyDetailResponseOutputLastUsedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const notificationPolicyDetailResponseOutputStepsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputStepsItemPositionMin = 0;
export const notificationPolicyDetailResponseOutputStepsItemPositionMax = 9007199254740991;

export const notificationPolicyDetailResponseOutputStepsItemDelayMinutesMin = 0;
export const notificationPolicyDetailResponseOutputStepsItemDelayMinutesMax = 1440;

export const notificationPolicyDetailResponseOutputStepsItemTargetOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputStepsItemTargetTwoScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputStepsItemTargetThreeTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputStepsItemChannelsMax = 3;

export const notificationPolicyDetailResponseOutputCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const notificationPolicyDetailResponseOutputUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d\\.\\d{3}(?:Z))$',
);
export const notificationPolicyDetailResponseOutputUpdatedByIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyDetailResponseOutputUpdatedByDisplayNameOneMax = 250;

export const notificationPolicyDetailResponseOutputTargetStatusItemStepIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const NotificationPolicyDetailResponseOutput = zod.object({
  id: zod.uuid().regex(notificationPolicyDetailResponseOutputIdRegExp),
  team: zod.object({
    id: zod.uuid().regex(notificationPolicyDetailResponseOutputTeamIdRegExp),
    name: zod.string().min(1).max(notificationPolicyDetailResponseOutputTeamNameMax),
  }),
  name: zod.string().min(1).max(notificationPolicyDetailResponseOutputNameMax),
  version: zod
    .int()
    .gt(notificationPolicyDetailResponseOutputVersionExclusiveMin)
    .max(notificationPolicyDetailResponseOutputVersionMax),
  enabled: zod.boolean(),
  stepCount: zod
    .int()
    .gt(notificationPolicyDetailResponseOutputStepCountExclusiveMin)
    .max(notificationPolicyDetailResponseOutputStepCountMax),
  minDelayMinutes: zod
    .int()
    .min(notificationPolicyDetailResponseOutputMinDelayMinutesMin)
    .max(notificationPolicyDetailResponseOutputMinDelayMinutesMax),
  maxDelayMinutes: zod
    .int()
    .min(notificationPolicyDetailResponseOutputMaxDelayMinutesMin)
    .max(notificationPolicyDetailResponseOutputMaxDelayMinutesMax),
  lastUsedAt: zod.union([
    zod.iso
      .datetime({ offset: true })
      .regex(notificationPolicyDetailResponseOutputLastUsedAtOneRegExp),
    zod.null(),
  ]),
  steps: zod
    .array(
      zod.object({
        id: zod.uuid().regex(notificationPolicyDetailResponseOutputStepsItemIdRegExp),
        position: zod
          .int()
          .min(notificationPolicyDetailResponseOutputStepsItemPositionMin)
          .max(notificationPolicyDetailResponseOutputStepsItemPositionMax),
        delayMinutes: zod
          .int()
          .min(notificationPolicyDetailResponseOutputStepsItemDelayMinutesMin)
          .max(notificationPolicyDetailResponseOutputStepsItemDelayMinutesMax),
        condition: zod.enum(['not-acknowledged', 'not-resolved']),
        target: zod.union([
          zod.object({
            kind: zod.literal('user'),
            userId: zod
              .uuid()
              .regex(notificationPolicyDetailResponseOutputStepsItemTargetOneUserIdRegExp),
          }),
          zod.object({
            kind: zod.literal('schedule'),
            scheduleId: zod
              .uuid()
              .regex(notificationPolicyDetailResponseOutputStepsItemTargetTwoScheduleIdRegExp),
          }),
          zod.object({
            kind: zod.literal('team'),
            teamId: zod
              .uuid()
              .regex(notificationPolicyDetailResponseOutputStepsItemTargetThreeTeamIdRegExp),
          }),
        ]),
        channels: zod
          .array(zod.enum(['email', 'sms', 'voice']))
          .min(1)
          .max(notificationPolicyDetailResponseOutputStepsItemChannelsMax),
      }),
    )
    .min(1),
  createdAt: zod.iso
    .datetime({ offset: true })
    .regex(notificationPolicyDetailResponseOutputCreatedAtRegExp),
  updatedAt: zod.iso
    .datetime({ offset: true })
    .regex(notificationPolicyDetailResponseOutputUpdatedAtRegExp),
  updatedBy: zod.object({
    id: zod.union([
      zod.uuid().regex(notificationPolicyDetailResponseOutputUpdatedByIdOneRegExp),
      zod.null(),
    ]),
    displayName: zod.union([
      zod.string().max(notificationPolicyDetailResponseOutputUpdatedByDisplayNameOneMax),
      zod.null(),
    ]),
  }),
  targetStatus: zod.array(
    zod.object({
      stepId: zod.uuid().regex(notificationPolicyDetailResponseOutputTargetStatusItemStepIdRegExp),
      reason: zod.enum([
        'available',
        'inactive-user',
        'inactive-team',
        'inactive-schedule',
        'missing-contact',
        'uncovered',
        'unavailable',
      ]),
    }),
  ),
});

export type NotificationPolicyDetailResponseOutput = zod.input<
  typeof NotificationPolicyDetailResponseOutput
>;
export type NotificationPolicyDetailResponseOutputOutput = zod.output<
  typeof NotificationPolicyDetailResponseOutput
>;
